import type { ListedProductFragment } from '~/generated/graphql';
import { ProductCard } from './ProductCard';

type ProductGridProps = {
  products: ListedProductFragment[];
};

export default function ProductGrid({ products }: ProductGridProps) {
  if (!products.length) return <div>No products found.</div>;

  return (
    <section className="max-w-[1440px] mx-auto px-4 lg:px-16 space-y-4 mt-6">
      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-10">
        {products.map((product) => (
          <ProductCard {...product} key={product.productVariantId} />
        ))}
      </div>
    </section>
  );
}
